require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./diversity-scholarship-fund.json") })
        }
      }, "path---diversity-scholarship-fund");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---diversity-scholarship-fund!./.cache/json/diversity-scholarship-fund.json
// module id = 1174
// module chunks = 231608221292675